import addressIcon from '@/assets/images/icons/Address.svg';
import bathtubIcon from '@/assets/images/icons/Bathtub.svg';
import budgetIcon from '@/assets/images/icons/Budget.svg';
import elevatorIcon from '@/assets/images/icons/Elevator.svg';
import familyIcon from '@/assets/images/icons/Family.svg';
import garageIcon from '@/assets/images/icons/Garage.svg';
import m2Icon from '@/assets/images/icons/m2.svg';
import parkingIcon from '@/assets/images/icons/Parking.svg';
import showerIcon from '@/assets/images/icons/Shower.svg';
import toiletIcon from '@/assets/images/icons/Toilet.svg';
import localiIcon from '@/assets/images/icons/home-4-line.svg';

export default {
  data() {
    return {
      campiEscluderePerTitolo: [
        'documentazione_auto', 'newsletter', 'published', 'showcase', 'affittato_venduto', 'in_gestione', 'nostra_proprieta', 'pub_tutti', 'pub_homegate',
        'cerca_subentrante', 'id', 'code', 'alert_emails', 'images', 'documents', 'stabile_field', 'stabile_name', 'testo_risposta_automatica', 'matterport_url'
      ],
      defaultProductDetailsWidgets: [
        { id: 1, icon: addressIcon, label: "Città:", labelDetail: "" },
        { id: 2, icon: localiIcon, label: "No. Locali:", labelDetail: "" },
        { id: 3, icon: budgetIcon, label: "Prezzo:", labelDetail: "" },
        { id: 4, icon: elevatorIcon, label: "Ascensore", labelDetail: "" },
        { id: 5, icon: familyIcon, label: "Adatto per famiglie", labelDetail: "" },
        { id: 6, icon: toiletIcon, label: "Wc:", labelDetail: "" },
        { id: 7, icon: showerIcon, label: "Doccia: ", labelDetail: "" },
        { id: 8, icon: bathtubIcon, label: "Vasche:", labelDetail: "" },
        { id: 9, icon: parkingIcon, label: "Parcheggio:", labelDetail: "" },
        { id: 10, icon: garageIcon, label: "Garage:", labelDetail: "" },
        { id: 11, icon: m2Icon, label: "Superficie abitabile:", labelDetail: "" }
      ]
    };
  },
  methods: {
    formatFullAddress(data) {
      return [
        data.street ? data.street + (data.unit_name ? '/' + data.unit_name : '') : '',
        data.city,
        data.npa,
        data.region,
        data.nation
      ].filter(part => part && String(part).trim())
      .join(', ');
    },
    formatShortAddress(data) {
      return [
        data.street,
        data.npa, data.city,
      ].filter(part => part && String(part).trim())
      .join(', ');
    },
    generateTitle(doc) {
      let title = '';
      if (doc.publication_title && doc.publication_title.trim() !== '') {
        title = doc.publication_title.trim();
      } else {
        let titleComponents = Object.entries(doc)
          .filter(([key, value]) =>
            !this.campiEscluderePerTitolo.includes(key) &&  // Check if the key is not in the excluded list
            !(typeof value === 'boolean' && !value)  // Exclude boolean fields that are false
          )
          .map(([key, value]) => {
            if (value === null || value === undefined || key === 'publication_title') return '';
            value = value.toString().trim();
            const formattedKey = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            return value ? `${formattedKey}: ${value}` : '';
          })
          .filter(entry => entry !== ''); // Remove any entries that turned out to be empty
        title = titleComponents.join(' - '); // Join non-empty label-value pairs with a separator
      }
      return title; // Return the generated title
    },
    formatListingSummary(doc) {
      let summaryParts = [];
      if (doc.valuta && doc.price) {
        summaryParts.push(`${doc.valuta} ${this.formatPrice(doc.price)}`);
      }
      if (doc.local) {
        summaryParts.push(`${doc.local} locali`);
      }
      if (doc.habitable_surface) {
        summaryParts.push(`${doc.habitable_surface} m²`);
      }
      return summaryParts.join('. ') + (summaryParts.length > 0 ? '.' : '');
    },
    formatPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    },
    setProductDetailsWidgets(doc) {
      const widgets = JSON.parse(JSON.stringify(this.defaultProductDetailsWidgets));
      widgets[0].labelDetail = doc.city ? `${doc.city}` : 'N/A';
      widgets[1].labelDetail = doc.local ? `${doc.local}` : 'N/A';
      widgets[2].labelDetail = doc.price ? `${doc.valuta} ${this.formatPrice(doc.price)}` : 'N/A';
      widgets[3].labelDetail = doc.elevator ? `` : 'N/A';
      widgets[4].labelDetail = doc.family_friendly ? `` : 'N/A';
      widgets[5].labelDetail = doc.toilets ? `${doc.toilets}` : 'N/A';
      widgets[6].labelDetail = doc.shower ? `${doc.shower}` : 'N/A';
      widgets[7].labelDetail = doc.bathtub ? `${doc.bathtub}` : 'N/A';
      widgets[8].labelDetail = doc.parkings ? `${doc.parkings}` : 'N/A';
      widgets[9].labelDetail = doc.garages ? `${doc.garages}` : 'N/A';
      widgets[10].labelDetail = doc.habitable_surface ? `${doc.habitable_surface}` : 'N/A';
      return widgets;
    },
    getFilteredProductDetailsWidgets(widgets) {
      return widgets.filter(item => item.labelDetail !== 'N/A');
    }
  }
};

